<footer class="footer">
    <div class="footer-content">
        <div class="container">
            <div class="row m-0">
                <div class="col-lg-12">
                    <div class="footer-link text-center">
                        <a [routerLink]="['/video-conference']">{{"videoConferenceTitle" | translate}}</a>
                        <a [routerLink]="['/hair-salon']">{{"hairSalonTitle" | translate}}</a>
                        <a [routerLink]="['/companies']">{{ "companiesTitle" | translate }}</a>
                        <a [routerLink]="['/charities']">{{ "charitiesTitle" | translate }}</a>
                        <a [routerLink]="['/fundraisers']">{{ "fundraisers" | translate }}</a>
                        <a [routerLink]="['/shop']">{{ "eCommerceTitle" | translate }}</a>
                        <a [routerLink]="['/service']">{{ "services" | translate }}</a>
                        <a [routerLink]="['/politician']">{{ "politicians" | translate }}</a>
                        <a [routerLink]="['/terms']">{{'terms' | translate}}</a>
                        <a [routerLink]="['/privacy']">{{'privacy' | translate}}</a>
                        <a [routerLink]="['/faq']">{{'faq' | translate}}</a>
                        <a [routerLink]="['/event-hosting']">{{'events' | translate}} </a>
                        <a [routerLink]="['/influencer']">{{'influencer-marketing' | translate}}</a>
                        <a [routerLink]="['/contact']">{{'contact' | translate}} </a>
                        <a [routerLink]="['/jobs']">{{'Jobs' | translate}} </a>
                        <a [routerLink]="['/restaurants']">{{ "RestaurantFooter" | translate }}</a>
                        <a [routerLink]="['/beats/list']">{{ "Beatmaker" | translate }}</a>
                        <a [routerLink]="['/online-course']">{{ "online-course" | translate }}</a>
                        <a [routerLink]="['/calendly']">{{ "calendlyFooter" | translate }}</a>
                        <a (click)="navigateToAcademy()">{{"mstAcademyFooter" | translate}}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <p class="m-b-0 text-center">© MyTrendingStories {{date| date:'yyyy'}}</p>

</footer>